import { Link } from "react-router-dom";

export default function FooterLinks() {
  return <footer className="legal-footer" data-testid="legal-footer">
    <Link to="/impressum" data-testid="footer-impressum-link">Impressum</Link>
    <Link to="/datenschutz" data-testid="footer-privacy-link">Datenschutzerklärung</Link>
  </footer>;
}